import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './city.reducer';

export const CityDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const cityEntity = useAppSelector(state => state.city.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="cityDetailsHeading">
          <Translate contentKey="rainspotApp.city.detail.title">City</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{cityEntity.id}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="rainspotApp.city.name">Name</Translate>
            </span>
          </dt>
          <dd>{cityEntity.name}</dd>
          <dt>
            <span id="region">
              <Translate contentKey="rainspotApp.city.region">Region</Translate>
            </span>
          </dt>
          <dd>{cityEntity.region}</dd>
          <dt>
            <span id="state">
              <Translate contentKey="rainspotApp.city.state">State</Translate>
            </span>
          </dt>
          <dd>{cityEntity.state}</dd>
          <dt>
            <span id="county">
              <Translate contentKey="rainspotApp.city.county">County</Translate>
            </span>
          </dt>
          <dd>{cityEntity.county}</dd>
          <dt>
            <Translate contentKey="rainspotApp.city.organization">Organization</Translate>
          </dt>
          <dd>{cityEntity.organization ? cityEntity.organization.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/city" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/city/${cityEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default CityDetail;
